import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const VideoSection = () => {
  const [video, setVideo] = useState([]);
  const [items, setItems] = useState([]);

  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);


  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/videos`)
      .then((res) => res.json())
      .then((info) => setVideo(info));
  }, []);

  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/videos-items`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);

  return (



    <>


      {
        video.map(b => b.pageSlug === page.pageSlug &&
          <section id="content-12" className="content-12 wide-60 content-section division">
            <div className="container">
              {/* SECTION TITLE */}
              <div className="row">
                <div className="col-lg-10 offset-lg-1">
                  <div className="section-title text-center mb-40">
                    {/* Title 	*/}
                    <h3 className="h3-md">{b.headingVideo}</h3>
                    {/* Text */}
                    <p className="p-lg">{b.TextVideo}
                    </p>
                  </div>
                </div>
              </div>
              {/* TEXT BLOCK */}
              <div className="row">
                <div className="col-xl-10 offset-xl-1 p-5">
                  {/* VIDEO PREVIEW */}
                  <div className="video-preview mb-80 wow fadeInUp" data-wow-delay="0.4s">
                    <a className="video-popup3" href={b.videoLink}>  {/* Change the link HERE!!! */}
                      {/* Play Icon */}
                      <div className="video-btn bg-orangered">
                        <div className="video-block-wrapper"><i className="fas fa-play" /></div>
                      </div>
                      {/* Preview Image */}
                      <img className="img-fluid" src={b.videoImage} alt="content-image" />
                    </a>
                  </div>	{/* END VIDEO PREVIEW */}

                </div>
              </div>	  {/* END TEXT BLOCK */}
            </div>     {/* End container */}
          </section>)}



    </>
  );
};

export default VideoSection;
